import { render, staticRenderFns } from "./FormSpinbuttonWrap.vue?vue&type=template&id=53de6f4a&"
import script from "./FormSpinbuttonWrap.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports